module.exports = __webpack_public_path__ + "static/media/hat_o.f0897294.ogg";